import local from "../../../util/local";
import { getModTypeExtensions } from "./modTypeExtensions";
import * as path from "path";
// "decorate" IGame objects with added functionality
const gameExHandler = {
    get: (target, key) => {
        if (key === "getModPaths") {
            const applicableExtensions = getModTypeExtensions().filter((ex) => ex.isSupported(target.id));
            const extTypes = applicableExtensions.reduce((prev, val) => {
                const typePath = val.getPath(target);
                if (typePath !== undefined) {
                    prev[val.typeId] = typePath;
                }
                return prev;
            }, {});
            return (gamePath) => {
                let defaultPath = target.queryModPath(gamePath);
                if (!defaultPath) {
                    defaultPath = ".";
                }
                if (!path.isAbsolute(defaultPath)) {
                    defaultPath = path.resolve(gamePath, defaultPath);
                }
                return {
                    ...extTypes,
                    "": defaultPath,
                };
            };
        }
        else if (key === "modTypes") {
            return getModTypeExtensions().filter((ex) => ex.isSupported(target.id));
        }
        else if (key === "getInstalledVersion") {
            return (discovery) => gvm.gameVersionManager.getGameVersion(target, discovery);
        }
        else {
            return target[key];
        }
    },
};
function makeGameProxy(game) {
    if (game === undefined) {
        return undefined;
    }
    return new Proxy(game, gameExHandler);
}
// this isn't nice...
const $ = local("gamemode-management", {
    gameModeManager: undefined,
    extensionGames: [],
    extensionStubs: [],
});
// ...neither is this
const gvm = local("gameversion-manager", {
    gameVersionManager: undefined,
});
// ...or this
export function getGames() {
    if ($.gameModeManager === undefined) {
        throw new Error("getGames only available in renderer process");
    }
    return $.gameModeManager.games.map(makeGameProxy);
}
export function getGame(gameId) {
    let game = $.extensionGames.find((iter) => iter.id === gameId);
    if (game === undefined) {
        const stub = $.extensionStubs.find((iter) => iter.game.id === gameId);
        if (stub !== undefined) {
            game = stub.game;
        }
    }
    return makeGameProxy(game);
}
export function getGameStubDownloadInfo(gameId) {
    const stub = $.extensionStubs.find((iter) => iter.game.id === gameId);
    return stub?.ext;
}
export function getGameStores() {
    if ($.gameModeManager === undefined) {
        throw new Error("getGameStores only available in renderer process");
    }
    return $.gameModeManager.gameStores || [];
}
export function getGameStore(id) {
    return $.gameModeManager.gameStores.find((store) => store.id === id);
}
